import { Alert } from '@/components/feedback/Alert'
import { Button } from '@/components/ui/button'
import { messages } from '@/lib/messages'

/**
 * Bayat sürümle kaydetme reddedildi (409 `record_changed`): kimin ne zaman değiştirdiğini söyler,
 * yerel değişikliklerin ekranda durduğunu belirtir ve "Yeniden yükle" sunar. Formun üstüne satır içi
 * konur; genel hata toast'ının yerini alır (`lib/form/use-record-version.tsx`).
 */
export function RecordConflictAlert({
  label,
  onReload,
  pending = false,
  failed = false,
  className,
}: {
  /** Ör. "Ayşe Yılmaz 14:05'te değiştirdi" (`recordChangedMessage`). */
  label: string
  onReload: () => void
  pending?: boolean
  /** Yeniden yükleme başarısız oldu; açıklama yerine bunu söyler. */
  failed?: boolean
  className?: string
}) {
  const t = messages.recordConflict
  return (
    <Alert
      tone="danger"
      title={`${t.title}: ${label}`}
      className={className}
      action={
        <Button type="button" size="sm" variant="outline" loading={pending} onClick={onReload}>
          {t.reload}
        </Button>
      }
    >
      {failed ? t.reloadFailed : t.description}
    </Alert>
  )
}
